var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('appQuoteViewCom',{attrs:{"propsData":_vm.getQuoteSingle,"quoteType":'leads'},on:{"callSingleQuote":function($event){return _vm.fnCallSingleQuote()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }